import { GamificationIconButton } from '@crehana/compass.layouts/topbar/components/gamification-icon-button';
import { LazyNotificationsIconButton } from '@crehana/compass.layouts/topbar/components/notifications-icon-button';

export const TopBarRightMenuComponents = () => {
  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <GamificationIconButton />
      <LazyNotificationsIconButton />
    </div>
  );
};
